/*/ ## EF.Collections.ResponsesCollection
//
// Collection for responses to individual questions */
(function(EF, undefined) {

  var ResponsesCollection = Backbone.Collection.extend({
    initialize: function(responses, options) {
      this.response_set = options.response_set;
    },
    model: EF.Models.Response,
    url: function() {
      return this.response_set.url().replace('.json', '') + '/responses' + '.json';
    },
    toJSON: function() {
      return Backbone.Collection.prototype.toJSON.apply(this).reduce(function(result, value, index) {
        result.responses[index] = {
          response: {
            question_id: value.response.question_id, answer_id: value.response.answer_id
          }
        };
        return result;
      }, { responses: {} });
    }
  });

  _.extend(EF.Collections, {
    ResponsesCollection: ResponsesCollection
  });

})(EF);
